import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import Icon from "./Icon";
import { jsx as _jsx } from "react/jsx-runtime";
function WaitingRoom(props) {
  return /*#__PURE__*/_jsx(Icon, _extends({}, props, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M2 21v-2h18v2H2ZM20 8V5h-2v3h2Zm0-5a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V3h16Zm-4 2H6v8a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V5Z"
    })
  }));
}
export default WaitingRoom;